// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as N_RewardType from "../types/N_RewardType.bs.js";
import * as N_RewardStatus from "../types/N_RewardStatus.bs.js";
import * as N_RewardCategory from "../types/N_RewardCategory.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as N_VehicleCategory from "../types/N_VehicleCategory.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";

function slabsDecoder(json) {
  return {
          orderCount: Json_decode.field("order_count", Json_decode.$$int, json),
          points: Json_decode.field("points", Json_decode.$$int, json)
        };
}

function getDecodedComputer(json) {
  return {
          computerType: N_RewardType.fromString(Json_decode.field("type", Json_decode.string, json)),
          minRating: Json_decode.optional((function (param) {
                  return Json_decode.field("min_rating", Json_decode.$$int, param);
                }), json),
          points: Json_decode.optional((function (param) {
                  return Json_decode.field("points", Json_decode.$$int, param);
                }), json),
          windowStartMins: Json_decode.optional((function (param) {
                  return Json_decode.field("window_start_mins", Json_decode.$$int, param);
                }), json),
          windowEndMins: Json_decode.optional((function (param) {
                  return Json_decode.field("window_end_mins", Json_decode.$$int, param);
                }), json),
          perHourPoints: Json_decode.optional((function (param) {
                  return Json_decode.field("per_hour_points", Json_decode.$$int, param);
                }), json),
          slabs: Json_decode.optional((function (param) {
                  return Json_decode.field("slabs", (function (param) {
                                return Json_decode.list(slabsDecoder, param);
                              }), param);
                }), json)
        };
}

function getTypedComputer(computer) {
  var match = computer.computerType;
  switch (match) {
    case /* OrderRating */0 :
        return {
                TAG: /* OrderRatingComputer */0,
                _0: {
                  computerType: computer.computerType,
                  minRating: Belt_Option.getWithDefault(computer.minRating, 0),
                  points: Belt_Option.getWithDefault(computer.points, 0)
                }
              };
    case /* LoginHours */1 :
        return {
                TAG: /* LoginHourComputer */1,
                _0: {
                  computerType: computer.computerType,
                  windowStartMins: Belt_Option.getWithDefault(computer.windowStartMins, 0),
                  windowEndMins: Belt_Option.getWithDefault(computer.windowEndMins, 0),
                  perHourPoints: Belt_Option.getWithDefault(computer.perHourPoints, 0)
                }
              };
    case /* OrderFulfillment */2 :
        var slabs = computer.slabs;
        return {
                TAG: /* OrderFulfillmentComputer */2,
                _0: {
                  computerType: computer.computerType,
                  slabs: slabs !== undefined ? slabs : ErrorUtils$Catalyst.raiseError("N_RnrEntityMapper.res", "No computer slabs provided", "")
                }
              };
    
  }
}

function computerDecoder(json) {
  return getTypedComputer(getDecodedComputer(json));
}

function getLuckyDrawAward(json) {
  return {
          TAG: /* LuckyDrawAward */0,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json)),
            awardType: Json_decode.field("type", Json_decode.string, json)
          }
        };
}

function getNoAward(json) {
  return {
          TAG: /* NoAward */1,
          _0: {
            awardedAt: DateTime$Catalyst.fromTimeStamp(Json_decode.field("awarded_at", Json_decode.$$int, json))
          }
        };
}

function awardDecoder(json) {
  var awardType = Json_decode.field("type", Json_decode.string, json);
  switch (awardType) {
    case "LUCKY_DRAW" :
        return getLuckyDrawAward(json);
    case "NO_AWARD" :
        return getNoAward(json);
    default:
      return getNoAward(json);
  }
}

function cycleCategoryAggDecoder(json) {
  return {
          name: N_RewardCategory.fromString(Json_decode.field("category", Json_decode.string, json)),
          points: Json_decode.field("points", Json_decode.$$int, json),
          computers: Json_decode.field("computers", (function (param) {
                  return Json_decode.list(computerDecoder, param);
                }), json)
        };
}

function milestoneDecoder(json) {
  return {
          name: String(Json_decode.field("points", Json_decode.$$int, json)),
          points: Json_decode.field("points", Json_decode.$$int, json),
          award: Json_decode.optional((function (param) {
                  return Json_decode.field("award", awardDecoder, param);
                }), json)
        };
}

function rnrCycleDecoder(json) {
  return {
          startDate: Json_decode.field("start_date", Json_decode.string, json),
          endDate: Json_decode.field("end_date", Json_decode.string, json)
        };
}

function dailyRewardsDecoder(json) {
  return {
          entitlementDate: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("entitlement_date", Json_decode.string, json)),
          id: Json_decode.field("id", Json_decode.$$int, json),
          rewardType: N_RewardType.fromString(Json_decode.field("type", Json_decode.string, json)),
          points: Json_decode.field("points", Json_decode.$$int, json),
          status: N_RewardStatus.fromString(Json_decode.field("status", Json_decode.string, json)),
          category: N_RewardCategory.fromString(Json_decode.field("category", Json_decode.string, json)),
          expiryTime: Json_decode.field("expiry_ts", Json_decode.$$int, json),
          qualifiedOrders: Json_decode.optional((function (param) {
                  return Json_decode.field("qualified_order_count", Json_decode.$$int, param);
                }), json),
          completedOrders: Json_decode.optional((function (param) {
                  return Json_decode.field("completed_order_count", Json_decode.$$int, param);
                }), json),
          loginHours: Json_decode.optional((function (param) {
                  return Json_decode.field("login_hours", Json_decode.$$float, param);
                }), json),
          driverCancelledCount: Json_decode.optional((function (param) {
                  return Json_decode.field("driver_cancelled_count", Json_decode.$$int, param);
                }), json),
          completedCount: Json_decode.optional((function (param) {
                  return Json_decode.field("completed_count", Json_decode.$$int, param);
                }), json)
        };
}

function orderRatingRewardsDecoder(reward) {
  return {
          entitlementDate: reward.entitlementDate,
          id: reward.id,
          rewardType: reward.rewardType,
          points: reward.points,
          status: reward.status,
          category: reward.category,
          expiryTime: reward.expiryTime,
          qualifiedOrders: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.qualifiedOrders),
          completedOrders: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.completedOrders)
        };
}

function loginHourRewardsDecoder(reward) {
  return {
          entitlementDate: reward.entitlementDate,
          id: reward.id,
          rewardType: reward.rewardType,
          points: reward.points,
          status: reward.status,
          category: reward.category,
          expiryTime: reward.expiryTime,
          loginHours: OptionTypeUtils$Catalyst.getFloatFrmOptionalTypeStrict(reward.loginHours)
        };
}

function orderFulfillmentRewardsDecoder(reward) {
  return {
          entitlementDate: reward.entitlementDate,
          id: reward.id,
          rewardType: reward.rewardType,
          points: reward.points,
          status: reward.status,
          category: reward.category,
          expiryTime: reward.expiryTime,
          completedOrders: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.completedCount),
          driverCancelledCount: OptionTypeUtils$Catalyst.getIntFrmOptionalTypeStrict(reward.driverCancelledCount)
        };
}

function weeklyPointDecoder(json) {
  return {
          start_date: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("start_date", Json_decode.string, json)),
          end_date: DateTime$Catalyst.fromString("YYYY-MM-DD", Json_decode.field("end_date", Json_decode.string, json)),
          point: Json_decode.field("points", Json_decode.$$int, json)
        };
}

function execute(json) {
  var dailyRewardList = Json_decode.field("rewards", (function (param) {
          return Json_decode.list(dailyRewardsDecoder, param);
        }), json);
  var getRewardList = function (category) {
    return List.filter(function (reward) {
                  return reward.category === category;
                })(dailyRewardList);
  };
  var customerExperienceRewardList = List.map(orderRatingRewardsDecoder, getRewardList(/* CustomerService */0));
  var loginHourRewardList = List.map(loginHourRewardsDecoder, getRewardList(/* LoginActivity */1));
  var orderFulfillmentRewardList = List.map(orderFulfillmentRewardsDecoder, getRewardList(/* OrderFulfillment */2));
  return {
          cycleCategoryAgg: Json_decode.field("cycle_category_aggregates", (function (param) {
                  return Json_decode.list(cycleCategoryAggDecoder, param);
                }), json),
          dailyRewards: {
            orderRatingRewards: customerExperienceRewardList,
            loginHourRewards: loginHourRewardList,
            orderFulfillmentRewards: orderFulfillmentRewardList
          },
          milestones: Json_decode.field("milestones", (function (param) {
                  return Json_decode.list(milestoneDecoder, param);
                }), json),
          rnrCycle: Json_decode.field("rnr_cycle", rnrCycleDecoder, json),
          weeklyReport: Json_decode.field("weekly_point_report", (function (param) {
                  return Json_decode.list(weeklyPointDecoder, param);
                }), json),
          vehicleCategory: N_VehicleCategory.fromString(Json_decode.field("vehicle_category", Json_decode.string, json))
        };
}

export {
  slabsDecoder ,
  getDecodedComputer ,
  getTypedComputer ,
  computerDecoder ,
  getLuckyDrawAward ,
  getNoAward ,
  awardDecoder ,
  cycleCategoryAggDecoder ,
  milestoneDecoder ,
  rnrCycleDecoder ,
  dailyRewardsDecoder ,
  orderRatingRewardsDecoder ,
  loginHourRewardsDecoder ,
  orderFulfillmentRewardsDecoder ,
  weeklyPointDecoder ,
  execute ,
  
}
/* N_RewardType Not a pure module */
